/**
 * Reserved usernames that cannot be claimed by users.
 * Includes PromptVan routes, common terms, and brand protection.
 * Checked during onboarding Step 1 and profile edit.
 */
export const RESERVED_USERNAMES = new Set([
  // App routes
  'admin', 'api', 'auth', 'blog', 'callback', 'confirm', 'dashboard',
  'discover', 'feed', 'health', 'help', 'home', 'login', 'logout',
  'onboarding', 'pricing', 'privacy', 'profile', 'reset-password',
  'review', 'search', 'settings', 'signup', 'status', 'support',
  'terms', 'u', 'undefined', 'null', 'waitlist',
  // Brand
  'promptvan', 'prompt-van', 'prompt_van', 'system', 'moderator',
  'anonymous', 'deleted',
])
